import "./navigation.css";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "antd";
import {
    aboutLink,
    contactLink,
    portfolioLinks,
    photographyLink,
    creatorPartnershipsLink,
    isPhotographyView,
    isCreatorPartnershipsView,
} from "./navConfig";
import { useTranslation } from "../../i18n";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { useWhiteLabel } from "../../whiteLabel/useWhiteLabel";

function Navigation() {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const { isWhiteLabel } = useWhiteLabel();
    const photographyActive = isPhotographyView(pathname);
    const creatorActive = isCreatorPartnershipsView(pathname);

    const portfolioMenu = {
        items: [
            ...portfolioLinks.map((link) => ({
                key: link.to,
                label: (
                    <Link
                        to={link.to}
                        className={pathname === link.to ? "nav-link-active" : ""}
                    >
                        {t(link.labelKey)}
                    </Link>
                ),
            })),
        ],
    };

    return (
        <nav className={`nav${isWhiteLabel ? " nav--white-label" : ""}`}>
            <ul className="nav-list">
                {!isWhiteLabel && (
                    <li>
                        <Link
                            to={aboutLink.to}
                            className={pathname === aboutLink.to ? "nav-link-active" : ""}
                        >
                            {t(aboutLink.labelKey)}
                        </Link>
                    </li>
                )}
                <li className="nav-view">
                    <Dropdown
                        menu={portfolioMenu}
                        trigger={["hover"]}
                        overlayClassName="nav-dropdown"
                    >
                        <Link
                            to={photographyLink.to}
                            className={`nav-view-trigger${
                                photographyActive ? " nav-link-active" : ""
                            }`}
                        >
                            {t(photographyLink.labelKey)}
                        </Link>
                    </Dropdown>
                </li>
                <li className="nav-view">
                    <Link
                        to={creatorPartnershipsLink.to}
                        className={creatorActive ? "nav-link-active" : ""}
                    >
                        {t(creatorPartnershipsLink.labelKey)}
                    </Link>
                </li>
                {!isWhiteLabel && (
                    <li>
                        <Link
                            to={contactLink.to}
                            className={pathname === contactLink.to ? "nav-link-active" : ""}
                        >
                            {t(contactLink.labelKey)}
                        </Link>
                    </li>
                )}
                <li className="nav-language">
                    <LanguageSwitcher />
                </li>
            </ul>
            <ul className="nav-list nav-list--mobile-views">
                <li>
                    <Link
                        to={photographyLink.to}
                        className={photographyActive ? "nav-link-active" : ""}
                    >
                        {t(photographyLink.labelKey)}
                    </Link>
                </li>
                <li>
                    <Link
                        to={creatorPartnershipsLink.to}
                        className={creatorActive ? "nav-link-active" : ""}
                    >
                        {t(creatorPartnershipsLink.labelKey)}
                    </Link>
                </li>
            </ul>
        </nav>
    );
}

export default Navigation;
